/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoAccasamentoUpdateDTO
 */
export interface MovimentoAccasamentoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoUpdateDTO
     */
    costoVaccino?: number;
}

/**
 * Check if a given object implements the MovimentoAccasamentoUpdateDTO interface.
 */
export function instanceOfMovimentoAccasamentoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoAccasamentoUpdateDTOFromJSON(json: any): MovimentoAccasamentoUpdateDTO {
    return MovimentoAccasamentoUpdateDTOFromJSONTyped(json, false);
}

export function MovimentoAccasamentoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoAccasamentoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'costoVaccino': !exists(json, 'costoVaccino') ? undefined : json['costoVaccino'],
    };
}

export function MovimentoAccasamentoUpdateDTOToJSON(value?: MovimentoAccasamentoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'costoVaccino': value.costoVaccino,
    };
}

